<div style="overflow: unset" id="params-detail-container">
    <div class="py-4 px-24 top-bg primary-400">
        <h2 class="py-0">{{"REPORTS.REPORT_DETAIL" | translate}}</h2>
    </div>

    <div style="overflow: scroll;height: 450px; max-height: 450px;" class="px-24 pb-0">
        <ng-container *ngFor="let param of requestedParameters">
           <ng-container *ngIf="!param?.includes('[')">
                <div fxLayout="row wrap" *ngIf="param?.split(':')[1]" class="pt-24">
                    <span><b>{{param?.split(':')[0]}}:&nbsp;</b></span>

                    <span>{{param?.split(':')[1]}}</span>
                </div>
           </ng-container>

           <ng-container *ngIf="param?.includes('[')"> <!--Includes '[' if is grid or multiple option-->
                <div fxLayout="column" class="pt-24">
                    <span><b>{{param?.split('[')[0]}}:&nbsp;</b></span>
                    <br>
                    <div class="grid-params-container">
                        <ng-container  *ngFor="let specialParam of param.split('[')[1].split('|')">
                            <div class="grid-param-box" *ngIf="specialParam?.includes(':')"> <!--Handle if is grid-->
                                <div class="p-8"style="min-height: 55px;">
                                    <span style="min-height: 55px;">
                                        <b>{{specialParam?.split(':')[0]}}</b>
                                    </span>
                                </div>
                                <!-- <ng-container *ngFor="let item of specialParam.split(':')[1].split(',')"> -->
                                    <mat-divider></mat-divider>
                                    <div class="p-8">
                                        <span>
                                            {{specialParam?.split(':')[1]?.includes(']') ?
                                            specialParam?.split(':')[1].substr(0, specialParam?.split(':')[1].length - 1) :
                                            specialParam?.split(':')[1]
                                            }}
                                        </span>
                                    </div>
                                <!-- </ng-container> -->
                            </div>

                            <div class="p-8 grid-param-box" *ngIf="!specialParam?.includes(':')"> <!--Handle if is multiple option-->
                                <span>
                                    {{specialParam?.includes(']') ? specialParam?.split(']')[0] : specialParam}}
                                </span>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <ng-container *ngFor="let param of specialParameters">
            <ng-container *ngIf="param.questionTypeId == 8">
                <app-table-input [completeTable]="param"></app-table-input>
            </ng-container>
        </ng-container>
    </div>

    <div align="end" class="p-16">
        <button mat-raised-button color="primary" (click)="onClose()">{{'DIALOGS.ACTIONS.ACCEPT' | translate}}</button>
    </div>
</div>
